/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AccountWebsiteRestrictionsQueryVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
}>;


export type AccountWebsiteRestrictionsQuery = { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly websiteRestrictions: { readonly __typename?: 'AccountWebsiteRestrictions', readonly domainsWhitelist: ReadonlyArray<string> | null, readonly maximumPageBundle: number | null, readonly maximumPageCapacity: number, readonly maximumUnverifiedWebsites: number | null, readonly maximumWebsites: number | null } } | null };


export const AccountWebsiteRestrictionsDocument = gql`
    query AccountWebsiteRestrictions($accountId: AccountId!) {
  account(id: $accountId) {
    id
    websiteRestrictions {
      domainsWhitelist
      maximumPageBundle
      maximumPageCapacity
      maximumUnverifiedWebsites
      maximumWebsites
    }
  }
}
    `;

/**
 * __useAccountWebsiteRestrictionsQuery__
 *
 * To run a query within a React component, call `useAccountWebsiteRestrictionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountWebsiteRestrictionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountWebsiteRestrictionsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountWebsiteRestrictionsQuery(baseOptions: Apollo.QueryHookOptions<AccountWebsiteRestrictionsQuery, AccountWebsiteRestrictionsQueryVariables> & ({ variables: AccountWebsiteRestrictionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountWebsiteRestrictionsQuery, AccountWebsiteRestrictionsQueryVariables>(AccountWebsiteRestrictionsDocument, options);
      }
export function useAccountWebsiteRestrictionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountWebsiteRestrictionsQuery, AccountWebsiteRestrictionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountWebsiteRestrictionsQuery, AccountWebsiteRestrictionsQueryVariables>(AccountWebsiteRestrictionsDocument, options);
        }
export function useAccountWebsiteRestrictionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountWebsiteRestrictionsQuery, AccountWebsiteRestrictionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountWebsiteRestrictionsQuery, AccountWebsiteRestrictionsQueryVariables>(AccountWebsiteRestrictionsDocument, options);
        }
export type AccountWebsiteRestrictionsQueryHookResult = ReturnType<typeof useAccountWebsiteRestrictionsQuery>;
export type AccountWebsiteRestrictionsLazyQueryHookResult = ReturnType<typeof useAccountWebsiteRestrictionsLazyQuery>;
export type AccountWebsiteRestrictionsSuspenseQueryHookResult = ReturnType<typeof useAccountWebsiteRestrictionsSuspenseQuery>;
export type AccountWebsiteRestrictionsQueryResult = Apollo.QueryResult<AccountWebsiteRestrictionsQuery, AccountWebsiteRestrictionsQueryVariables>;